import { render, staticRenderFns } from "./MlbTeamStack.vue?vue&type=template&id=4a87b578&scoped=true"
import script from "./MlbTeamStack.vue?vue&type=script&lang=js"
export * from "./MlbTeamStack.vue?vue&type=script&lang=js"
import style0 from "./MlbTeamStack.vue?vue&type=style&index=0&id=4a87b578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87b578",
  null
  
)

export default component.exports